import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const state = {
	tableHight : '',
	isCollapsed : false,
	menu_id : '0-1',
	nav_id : '',
	token : window.localStorage.getItem('token'),//登录token,
	userinfo : window.localStorage.getItem('userinfo') && window.localStorage.getItem('userinfo') !== 'undefined' ? JSON.parse(window.localStorage.getItem('userinfo')) : '' ,
}

const mutations = {
	//导航伸缩
	SET_IS_COLLAPSED(state , data){
		state.isCollapsed = data;
	},
	//设置自适应高度
	SET_TABLE_HEIGHT(state , data){
		state.tableHight = data;
	},
	//设置导航ID
	SET_MENU_ID(state , data){
		state.menu_id = data;
		localStorage.setItem('menu_id', data);
	},
	//设置子导航ID
	SET_NAV_ID(state , data){
		state.nav_id = data;
		localStorage.setItem('nav_id', data);
	},
	SET_TOKEN(state , data){
		state.token = data;
		localStorage.setItem('token', data);
	},
	//设置用户信息
	SET_USERINFO(state , data){
		state.userinfo = data;
		localStorage.setItem('userinfo', JSON.stringify(data));
	},
	//设置路由信息
	SET_ROUTERS(state, routers){
		state.addRouters = routers
		state.routers = constantRouterMap.concat(routers)
		//这里将动态组装的路由添加到路由里面
		for(let x of state.routers){
			router.addRoute(x)
		}
	},
	//路由权限
	SET_AUTH(state , data){
		state.auth = data;
		localStorage.setItem('auth', data);
	}
}

const getters = {
	token(state){
		return state.token
	},
}

const actions = {}

export default new Vuex.Store({
	state,mutations,getters,actions
})


// WEBPACK FOOTER //
// ./src/store/store.js